document.addEventListener('keydown', (e) => {
  // Check if the pressed key is Escape
  if (e.key === 'Escape') {
    // Check if the Iubenda banner is currently in the DOM
    const iubendaBanner = document.getElementById('iubenda-cs-banner');
    
    if (iubendaBanner && window._iub && _iub.cs && _iub.cs.api) {
      // Use the official Iubenda API to close/dismiss the banner
      _iub.cs.api.close();
    }
  }
});         